<header class="page-header">
    <div>
        <h1 class="page-header__title">{{ 'components.changeOrg.title' | translate }}</h1>
        <p class="page-header__description">{{ 'components.changeOrg.subtitle' | translate }}</p>
    </div>
</header>

<div class="card">
    <p-table [value]="organizations" [paginator]="true" [rows]="10" [alwaysShowPaginator]="false">
        <ng-template #caption>
            <app-searchbar class="org-search" (searchEvent)="onSearch($event)"></app-searchbar>
        </ng-template>
        <ng-template #body let-organization>
            <tr
                [class.cursor-pointer]="organization.isLicenseValid"
                [class.is-disabled]="!organization.isLicenseValid"
                (click)="onClickOrg(organization)">
                <td class="org-logo-cell">
                    <img class="org-logo" [src]="organization.avatar ?? fallBackLogo" alt="Logo" />
                </td>
                <td class="org-name">{{ organization.name }}</td>
                <td>{{ 'components.changeOrg.profile.' + organization.profile | translate }}</td>
                <td>{{ findLocationLabel(organization.country) ?? '--' }}</td>
                <td>
                    <div class="org-licence" [class.org-licence--expired]="!organization.isLicenseValid">
                        <span class="org-licence__status">
                            <span class="org-licence__dot" aria-hidden="true"></span>
                            {{
                                (organization.isLicenseValid
                                    ? 'components.changeOrg.valid'
                                    : 'components.changeOrg.expired'
                                ) | translate
                            }}
                        </span>
                        @if (!organization.isLicenseValid) {
                            <small class="org-licence__since">{{
                                ('components.changeOrg.since' | translate) + ' ' + getOrgValidity(organization)
                            }}</small>
                        }
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template #emptymessage>
            <tr>
                <td colspan="5">
                    <div class="empty-state empty-state--compact">{{ 'common.noData' | translate }}</div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
